<div *ngIf="state.isVisible" [ngClass]="{ open: state.isOpen }" class="onboarding">
  <div
    class="cta"
    allianceAtsShowOnboarding
    santaTooltip
    [tooltipContent]="tooltip"
    [tooltipAdditionalOffset]="10"
    [tooltipPosition]="TooltipPosition.left"
    atsAnalyticsPushEventOnClick
    [event]="analyticsEvent"
  >
    <alliance-icon class="santa-text-black-800" [inheritColor]="true" [width]="20" [name]="ICONS.IconDetailsQuestionMark.name"></alliance-icon>
  </div>
  <ng-container *ngIf="state.isOpen">
    <lib-categories-panel class="list" [@fadeInOut]></lib-categories-panel>
  </ng-container>
</div>

<ng-template #tooltip>
  <p class="santa-p-5">{{ translations.tooltip | translate }}</p>
</ng-template>
